var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.729 2.33874L13.4129 1.02264C13.2325 0.842041 13.013 0.751709 12.755 0.751709C12.4968 0.751709 12.2773 0.842041 12.0969 1.02264L5.74838 7.38071L2.90321 4.52583C2.72254 4.34517 2.5032 4.25494 2.24522 4.25494C1.98707 4.25494 1.76773 4.34517 1.58707 4.52583L0.270963 5.84197C0.0902984 6.0226 0 6.24201 0 6.50013C0 6.75804 0.0902984 6.97765 0.270963 7.15825L3.77413 10.6613L5.09033 11.9774C5.2709 12.1582 5.4903 12.2484 5.74838 12.2484C6.00637 12.2484 6.22577 12.1579 6.40644 11.9774L7.72261 10.6613L14.729 3.65495C14.9095 3.47429 15 3.25491 15 2.9968C15.0001 2.73881 14.9095 2.51941 14.729 2.33874Z",
    fill: "#BBC2D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheck);
export default __webpack_public_path__ + "static/media/icon-check.6c24fe46695025e18eaecb94b6695fe3.svg";
export { ForwardRef as ReactComponent };